import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const adminLabTradesRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/trades/master_trades',
  validateSearch: z.object({
    page: zodPage,
    query: z.string().optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/admin/LabTrades/AdminLabTradesPage/AdminLabTradesPage').then((d) => d.Route)
);
